<script>
import { BFormInvalidFeedback } from "bootstrap-vue";

export default {
  extends: BFormInvalidFeedback
};
</script>